import React, { useEffect, lazy, Suspense } from 'react';
import ErrorBoundary from 'containers/ErrorBoundary';
import { useLocation } from 'react-router-dom';

import Analytics from 'utils/analytics';

const RiskShieldModule = lazy(() =>
  import(
    /* webpackChunkName: "RiskShieldWebApp_RiskShield" */
    /* webpackPrefetch: true */
    // eslint-disable-next-line import/no-unresolved
    'RiskShieldWebApp/RiskShield'
  ),
);

const RiskShield = () => {
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const promo = query.get('promo');

    if (promo === 'pgriskshield') {
      Analytics.trackEventWithNewNomenclature({
        eventName: `Risk_Shield_${promo}`,
        eventProperties: {
          promo,
        },
      });
    }
  }, [location.search]);
  return (
    <ErrorBoundary fallback={<></>}>
      <Suspense fallback={<></>}>
        <RiskShieldModule basePath="risk-shield" product="PG" />
      </Suspense>
    </ErrorBoundary>
  );
};

export default RiskShield;
